import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-bool-as-icon',
  templateUrl: './bool-as-icon.component.html',
  styleUrls: ['./bool-as-icon.component.scss'],
})
export class BoolAsIconComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {}

}
